export default __webpack_public_path__ + "static/media/typescript.7f295534.svg";